import React from 'react';
import acm from './ClientForm.module.css';

const ClientViewForm = ({ clientData, sellerData }) => {
    console.log(clientData)
    const isCompany = clientData?.companyName && clientData.companyName.length > 0;
    
    return (
        <div>
            <fieldset className={acm.formField}>
                <legend>კლიენტი</legend>
                
                {sellerData && (
                    <div className={acm.groupInput}>
                        <label>გამყიდველი:</label>
                        <div className={acm.viewOnlyField}>
                            {sellerData.label || "არ არის მითითებული"}
                        </div>
                    </div>
                )}
                
                <div className={acm.inp2col} style={{ marginBottom: 0, marginTop: 10 }}>  
                    <div className={acm.groupInput}>
                        <label>ტელეფონი:</label>
                        <div className={acm.viewOnlyField}>
                            {clientData?.mobile || "არ არის მითითებული"}
                        </div>
                    </div>
                </div>
   
                <div className={acm.inpcol}>
                    {!isCompany && (
                        <>
                            <div className={acm.groupInput}>
                                <label>პირადი ნომერი:</label>
                                <div className={acm.viewOnlyField}>
                                    {clientData?.personal || "არ არის მითითებული"}
                                </div>
                            </div>
                            <div className={acm.inp2col}>
                                <div className={acm.groupInput}>
                                    <label>სახელი:</label>
                                    <div className={acm.viewOnlyField}>
                                        {clientData?.firstname || "არ არის მითითებული"}
                                    </div>
                                </div>
                                <div className={acm.groupInput}>
                                    <label>გვარი:</label>
                                    <div className={acm.viewOnlyField}>
                                        {clientData?.lastname || "არ არის მითითებული"}
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                </div>
 
                {isCompany && (
                    <div className={acm.inp2col}>
                        <div className={acm.groupInput}>
                            <label>კომპანიის დასახელება:</label>
                            <div className={acm.viewOnlyField}>
                                {clientData?.companyName || "არ არის მითითებული"}
                            </div>
                        </div>
                        <div className={acm.groupInput}>
                            <label>საინდენტიფიკაციო #:</label>
                            <div className={acm.viewOnlyField}>
                                {clientData?.companyIdentifier || "არ არის მითითებული"}
                            </div>
                        </div>
                    </div>
                )}

                <div className={acm.groupInput}>
                    <label>ელ-ფოსტა:</label>
                    <div className={acm.viewOnlyField}>
                        {clientData?.email || "არ არის მითითებული"}
                    </div>
                </div>

                <div className={acm.groupInput}>
                    <label>ტიპი:</label>
                    <div className={acm.viewOnlyField}>
                        {isCompany ? "კომპანია" : "ფიზიკური პირი"}
                    </div>
                </div>
            </fieldset>
        </div>
    );
};

export default ClientViewForm;